import {FC} from 'react';
//mui
import {ButtonProps, Button as MuiButton} from '@mui/material';
//constants
import {FILLED, PRIMARY} from '@/utils/constants';

const Button: FC<ButtonProps> = ({color, variant, disabled = false, title, ...rest}) => (
	<MuiButton {...rest} variant={variant || FILLED} color={color || PRIMARY} disabled={disabled}>
		{title}
	</MuiButton>
);

export default Button;
